import AirIcon from '@mui/icons-material/Air';
import BoltIcon from '@mui/icons-material/Bolt';
import ConstructionIcon from '@mui/icons-material/Construction';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import ToysIcon from '@mui/icons-material/Toys';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import { Box } from '@mui/material';
import { ReactElement, useState } from 'react';
import { imageBase } from '../../api/client';

type IconComponent = typeof Inventory2Icon;

// Icon for an equipment category, by name. Same rules and order as the iOS app's
// CategoryIcon.symbol(for:) so both show the same picture for a category.
export const categoryIcon = (category?: string): IconComponent => {
  const name = (category ?? '').toLowerCase();
  if (name.includes('blower') || name.includes('air mover') || name.includes('fan')) return ToysIcon;
  if (name.includes('dehumid')) return WaterDropIcon;
  if (name.includes('scrubber') || name.includes('hepa') || name.includes('purif')) return AirIcon;
  if (name.includes('generator') || name.includes('power')) return BoltIcon;
  if (name.includes('heater')) return LocalFireDepartmentIcon;
  if (name.includes('pump') || name.includes('extract')) return VerticalAlignBottomIcon;
  if (name.includes('ladder') || name.includes('tool')) return ConstructionIcon;
  if (name.includes('uncategorized')) return HelpOutlineIcon;
  return Inventory2Icon;
};

type CategoryIconProps = { category?: string; size?: number };

export const CategoryIcon = ({ category, size = 22 }: CategoryIconProps): ReactElement => {
  const Icon = categoryIcon(category);
  return <Icon sx={{ fontSize: size, color: 'text.secondary', flexShrink: 0 }} aria-hidden />;
};

type ProductThumbnailProps = { imageKey?: string | null; category?: string; size?: number };

// A product photo at text height; the category icon if there is none or it fails to load.
export const ProductThumbnail = ({ imageKey, category, size = 22 }: ProductThumbnailProps): ReactElement => {
  const [failed, setFailed] = useState(false);
  if (!imageKey || failed) {
    return <CategoryIcon category={category} size={size} />;
  }
  return (
    <Box
      component="img"
      src={`${imageBase(imageKey)}?height=${size * 2}`}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
      sx={{ width: size, height: size, objectFit: 'cover', borderRadius: '4px', flexShrink: 0 }}
    />
  );
};
